<ng-template #titleTpl let-i>
  <span [innerHTML]="i._text"></span>
  @if (i.optional) {
    <small class="st__head-optional" [innerHTML]="i.optional"></small>
  }
  @if (i.optionalHelp) {
    <nz-icon class="st__head-tip" nz-tooltip [nzTooltipTitle]="i.optionalHelp" nzType="question-circle" />
  }
</ng-template>
<ng-template #chkAllTpl let-custom>
  <label
    nz-checkbox
    class="st__checkall"
    [nzDisabled]="_allCheckedDisabled"
    [(ngModel)]="_allChecked"
    [nzIndeterminate]="_indeterminate"
    (ngModelChange)="checkAll()"
    [class.ant-table-selection-select-all-custom]="custom"
  ></label>
</ng-template>
<nz-table
  #table
  [nzData]="_data"
  [(nzPageIndex)]="pi"
  (nzPageIndexChange)="_change('pi')"
  [(nzPageSize)]="ps"
  (nzPageSizeChange)="_change('ps')"
  [nzTotal]="total"
  [nzShowPagination]="_isPagination"
  [nzFrontPagination]="false"
  [nzBordered]="bordered"
  [nzSize]="size"
  [nzLoading]="noColumns || _loading"
  [nzLoadingDelay]="loadingDelay"
  [nzLoadingIndicator]="loadingIndicator"
  [nzTitle]="header!"
  [nzFooter]="footer!"
  [nzScroll]="scroll"
  [nzVirtualItemSize]="virtualItemSize"
  [nzVirtualMaxBufferPx]="virtualMaxBufferPx"
  [nzVirtualMinBufferPx]="virtualMinBufferPx"
  [nzVirtualForTrackBy]="virtualForTrackBy"
  [nzNoResult]="noResult!"
  [nzPageSizeOptions]="page.pageSizes!"
  [nzShowQuickJumper]="page.showQuickJumper"
  [nzShowSizeChanger]="page.showSize"
  [nzPaginationPosition]="page.position!"
  [nzPaginationType]="page.type!"
  [nzItemRender]="page.itemRender!"
  [nzSimple]="page.simple"
  [nzShowTotal]="totalTpl"
  [nzWidthConfig]="_widthConfig"
  (contextmenu)="onContextmenu($event)"
  [class.st__no-column]="noColumns"
>
  @if (showHeader) {
    <thead>
      @for (row of _headers; track row) {
        <tr>
          @if ($first && expand) {
            <th nzWidth="50px" [rowSpan]="_headers.length" [nzLeft]="row[0].column._left ? true : false"></th>
          }
          @for (h of row; track h; let index = $index; let last = $last) {
            @let _c = h.column;
            <th
              [colSpan]="h.colSpan"
              [rowSpan]="h.rowSpan"
              [nzWidth]="$any(_c).width"
              [nzLeft]="_c._left"
              [nzRight]="_c._right"
              [class]="_c._className"
              [attr.data-col]="_c.indexKey"
              [attr.data-col-index]="index"
              [nzShowSort]="_c._sort.enabled"
              [nzSortDirections]="_c._sort.directions!"
              [nzSortOrder]="$any(_c)._sort.default"
              (nzSortOrderChange)="sort(_c, $event)"
              [nzCustomFilter]="!!_c.filter"
              [class.st__has-filter]="_c.filter"
              nz-resizable
              [nzDisabled]="last || $any(_c).resizable.disabled"
              [nzMaxWidth]="$any(_c).resizable.maxWidth"
              [nzMinWidth]="$any(_c).resizable.minWidth"
              [nzBounds]="$any(_c).resizable.bounds"
              [nzPreview]="$any(_c).resizable.preview"
              (nzResizeEnd)="colResize($event, _c)"
            >
              @if ($any(!last && !$any(_c).resizable.disabled)) {
                <nz-resize-handle nzDirection="right" (click)="_stopPropagation($event)">
                  <i></i>
                </nz-resize-handle>
              }
              @if (_c.__renderTitle) {
                <ng-template
                  [ngTemplateOutlet]="_c.__renderTitle!"
                  [ngTemplateOutletContext]="{ $implicit: h.column, index: index }"
                />
              } @else {
                @switch (_c.type) {
                  @case ('checkbox') {
                    @if (_c.selections!.length === 0) {
                      <ng-template [ngTemplateOutlet]="chkAllTpl" [ngTemplateOutletContext]="{ $implicit: false }" />
                    } @else {
                      <div class="ant-table-selection">
                        <ng-template [ngTemplateOutlet]="chkAllTpl" [ngTemplateOutletContext]="{ $implicit: true }" />
                        @if (_c.selections!.length) {
                          <div class="ant-table-selection-extra">
                            <div
                              nz-dropdown
                              nzPlacement="bottomLeft"
                              [nzDropdownMenu]="selectionMenu"
                              class="ant-table-selection-down st__checkall-selection"
                            >
                              <nz-icon nzType="down" />
                            </div>
                          </div>
                        }
                        <nz-dropdown-menu #selectionMenu="nzDropdownMenu">
                          <ul nz-menu class="ant-table-selection-menu">
                            @for (rw of _c.selections; track $index) {
                              <li nz-menu-item (click)="_rowSelection(rw)" [innerHTML]="rw.text"></li>
                            }
                          </ul>
                        </nz-dropdown-menu>
                      </div>
                    }
                  }
                  @default {
                    <ng-template [ngTemplateOutlet]="titleTpl" [ngTemplateOutletContext]="{ $implicit: _c.title }" />
                  }
                }
              }
              @if (_c.filter) {
                <st-filter
                  nz-th-extra
                  [col]="h.column"
                  [f]="_c.filter"
                  [locale]="locale"
                  (n)="handleFilterNotify($event)"
                  (handle)="_handleFilter(_c, $event)"
                />
              }
            </th>
          }
        </tr>
      }
    </thead>
  }
  <tbody
    class="st__body"
    cdkDropList
    [cdkDropListDisabled]="drag() === null"
    (cdkDropListDropped)="drag()?.dropped?.($event)"
    (cdkDropListEntered)="drag()?.entered?.($event)"
    (cdkDropListExited)="drag()?.exited?.($event)"
    (cdkDropListSorted)="drag()?.sorted?.($event)"
  >
    @if (!_loading) {
      <ng-template [ngTemplateOutlet]="bodyHeader!" [ngTemplateOutletContext]="{ $implicit: _statistical }" />
    }
    <ng-template #bodyTpl let-i let-index="index">
      <tr
        [attr.data-index]="index"
        (click)="_rowClick($event, i, index, false)"
        (dblclick)="_rowClick($event, i, index, true)"
        [class]="i._rowClassName"
        cdkDrag
      >
        @if (expand) {
          <td
            [nzShowExpand]="expand && i.showExpand !== false"
            [nzExpand]="i.expand"
            [nzExpandIcon]="expandIcon ? wrapExpandIcon : null"
            (nzExpandChange)="_expandChange(i, $event)"
            (click)="_stopPropagation($event)"
            nzWidth="50px"
            [nzLeft]="_columns[0]._left ? true : false"
          ></td>
          <ng-template #wrapExpandIcon>
            <span (click)="_expandChange(i, !i.expand)">
              <ng-template [ngTemplateOutlet]="expandIcon" [ngTemplateOutletContext]="{ $implicit: i, index: index }" />
            </span>
          </ng-template>
        }
        @for (c of _columns; track cIdx; let cIdx = $index) {
          @let props = i._values[cIdx].props;
          @if (props?.colSpan > 0 && props?.rowSpan > 0) {
            <td
              [nzLeft]="c._left"
              [nzRight]="c._right"
              [attr.data-col-index]="cIdx"
              [class]="c._className"
              [attr.colspan]="props?.colSpan === 1 ? null : props?.colSpan"
              [attr.rowspan]="props?.rowSpan === 1 ? null : props?.rowSpan"
            >
              @if (responsive) {
                <span class="ant-table-rep__title">
                  <ng-template [ngTemplateOutlet]="titleTpl" [ngTemplateOutletContext]="{ $implicit: c.title }" />
                </span>
              }
              <st-td [data]="_data" [i]="i" [index]="index" [c]="c" [cIdx]="cIdx" (n)="_handleTd($event)" />
            </td>
          }
        }
      </tr>
      <tr [nzExpand]="i.expand">
        <ng-template [ngTemplateOutlet]="expand" [ngTemplateOutletContext]="{ $implicit: i, index: index }" />
      </tr>
    </ng-template>
    @if (virtualScroll) {
      <ng-template nz-virtual-scroll let-i let-index="index">
        <ng-template [ngTemplateOutlet]="bodyTpl" [ngTemplateOutletContext]="{ $implicit: i, index: index }" />
      </ng-template>
    } @else {
      @for (i of _data; track trackBy($index, i)) {
        <ng-template [ngTemplateOutlet]="bodyTpl" [ngTemplateOutletContext]="{ $implicit: i, index: $index }" />
      }
    }
    @if (!_loading) {
      <ng-template [ngTemplateOutlet]="body!" [ngTemplateOutletContext]="{ $implicit: _statistical }" />
    }
  </tbody>
  <ng-template #totalTpl let-range="range" let-total>{{ renderTotal(total, range) }}</ng-template>
</nz-table>
<nz-dropdown-menu #contextmenuTpl="nzDropdownMenu">
  <ul nz-menu class="st__contextmenu">
    @for (i of contextmenuList; track $index) {
      @if (i.children!.length === 0) {
        <li nz-menu-item (click)="i.fn!(i)" [innerHTML]="i.text"></li>
      } @else {
        <li nz-submenu [nzTitle]="i.text">
          <ul>
            @for (ci of i.children; track $index) {
              <li nz-menu-item (click)="ci.fn!(ci)" [innerHTML]="ci.text"></li>
            }
          </ul>
        </li>
      }
    }
  </ul>
</nz-dropdown-menu>
